import React from 'react';
import { useSelector } from 'react-redux';
import { defineMessages, useIntl } from 'react-intl';
import { RootState } from '@v7/form/src/store';
import { ROUTE_TYPE } from '@v7/form/src/utils/constant';
import classNames from 'classnames';

const messages = defineMessages({
  sectionGroupEnded: {
    id: 'form.sectionGroup.ended',
    defaultMessage: '------ section group ended ------',
  },
  sectionGroupStarted: {
    id: 'form.sectionGroup.started',
    defaultMessage: '------ section group started ------',
  },
});

const SectionGroup = ({
  attrkey,
  hide,
  label,
  textAlignment,
  type,
}: {
  attrkey?: string;
  label?: string;
  textAlignment?: string;
  type?: string;
  hide?: boolean;
}) => {
  const intl = useIntl();
  const { formState } = useSelector((state: RootState) => state?.form) || {};
  if (formState === ROUTE_TYPE.RENDERER && !label) return null;

  return (
    <div
      id={attrkey}
      className={classNames('w-full text-lg font-medium flex', formState === ROUTE_TYPE.RENDERER && hide && 'hidden')}
      style={{ justifyContent: textAlignment }}
    >
      {label || intl.formatMessage(type ? messages.sectionGroupEnded : messages.sectionGroupStarted)}
    </div>
  );
};

export default SectionGroup;
